import { FC } from 'react'

import { Box } from '@mui/material'

import { useAppSelector } from '~/app/hooks'

export const DangerousFullPage: FC = (props) => (
  <Box sx={{ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, pt: 0, height: '100vh' }}>{props.children}</Box>
)

// TODO: 实现支持安全区域的 fixed 布局的 mixin
export const SafeFullPage: FC = (props) => {
  const navHide = useAppSelector((state) => state.Ui.navHide)
  const safeAreaInset = useAppSelector((state) => state.Ui.safeAreaInset)

  const top = navHide && safeAreaInset ? safeAreaInset.top : 0
  const bottom = navHide && safeAreaInset ? safeAreaInset.bottom : 0

  return (
    <Box
      // sx={{ position: 'fixed', top, bottom, left: 0, right: 0, pt: 8, height: `calc(100vh - ${top}px - ${bottom}px)` }}
      sx={{ position: 'fixed', top, bottom, left: 0, right: 0, pt: 8, maxHeight: '100%', overflow: 'auto' }}
    >
      {props.children}
    </Box>
  )
}
